import { useState, useEffect, useRef } from "react";

const css = `
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700;900&family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&display=swap');

*, *::before, *::after { margin:0; padding:0; box-sizing:border-box; }
:root {
  --gold:#d4af37; --gold-l:#f7e29c; --gold-d:#a88520;
  --black:#06050a; --black2:#0c0b10; --black3:#111018;
  --white:#f5f0e8; --wdim:rgba(245,240,232,0.65); --wfaint:rgba(245,240,232,0.35);
}
html { scroll-behavior:smooth; }
body {  background: url('/hero-bg.png') no-repeat center center;
  background-size: cover; background-attachment:fixed; color:var(--white); font-family:'Cormorant Garamond',Georgia,serif; overflow-x:hidden; }

#particles { position:fixed; inset:0; z-index:0; pointer-events:none; }

.nav {
  position:fixed; top:0; left:0; right:0; z-index:100;
  display:flex; align-items:center; justify-content:space-between;
  padding:16px 5%; background:rgba(6,5,10,0.82);
  backdrop-filter:blur(20px); border-bottom:1px solid rgba(212,175,55,0.12);
  transition:padding .4s, background .4s;
}
.nav.shrunk { padding:10px 5%; background:rgba(6,5,10,0.97); }
.nav-logo-wrap { display:flex; align-items:center; gap:12px; }
.nav-icon { width:40px; height:40px; }
.nav-icon svg { width:100%; height:100%; }
.nav-brand { font-family:'Cinzel',serif; font-size:18px; font-weight:700; color:var(--gold); letter-spacing:2px; }
.nav-brand span { color:var(--wdim); font-weight:400; font-size:12px; display:block; letter-spacing:3px; }
.nav-links { display:flex; gap:28px; align-items:center; }
.nav-links a { font-family:'Cinzel',serif; font-size:11px; letter-spacing:2.5px; text-transform:uppercase; color:var(--wdim); text-decoration:none; transition:color .3s; position:relative; }
.nav-links a::after { content:''; position:absolute; bottom:-4px; left:0; right:0; height:1px; background:var(--gold); transform:scaleX(0); transition:transform .3s; }
.nav-links a:hover { color:var(--gold); }
.nav-links a:hover::after { transform:scaleX(1); }
.nav-cta { padding:9px 22px; background:linear-gradient(135deg,var(--gold),var(--gold-l)); color:#000; font-family:'Cinzel',serif; font-size:11px; letter-spacing:2px; font-weight:700; border:none; border-radius:2px; cursor:pointer; transition:all .3s; }
.nav-cta:hover { transform:translateY(-2px); box-shadow:0 6px 20px rgba(212,175,55,0.45); }

.hero {
  min-height:100vh; display:flex; flex-direction:column; justify-content:center; align-items:center;
  text-align:center; padding:140px 5% 80px; position:relative; z-index:1; overflow:hidden;
}
.hero::before {
  content:''; position:absolute; inset:0;
  background: radial-gradient(ellipse 60% 55% at 50% 40%,rgba(212,175,55,0.10) 0%,transparent 65%),
              radial-gradient(ellipse 30% 30% at 20% 70%,rgba(180,130,10,0.06) 0%,transparent 50%),
              radial-gradient(ellipse 30% 30% at 80% 20%,rgba(180,130,10,0.06) 0%,transparent 50%);
  pointer-events:none;
}
.hero::after {
  content:''; position:absolute; width:200%; height:3px;
  background:linear-gradient(90deg,transparent,rgba(212,175,55,0.4),transparent);
  top:45%; left:-50%; animation:sweep 7s ease-in-out infinite; pointer-events:none;
}
@keyframes sweep { 0%,100%{opacity:0;transform:translateX(0) rotate(-8deg)} 50%{opacity:.5;transform:translateX(50%) rotate(-8deg)} }

.logo-wrap { position:relative; width:160px; height:160px; margin-bottom:28px; animation:logoIn 1.2s cubic-bezier(.16,1,.3,1) both; }
@keyframes logoIn { from{opacity:0;transform:scale(.4) rotate(-20deg)} to{opacity:1;transform:scale(1) rotate(0)} }
.logo-ring { position:absolute; inset:-18px; border-radius:50%; border:1px solid rgba(212,175,55,0.22); animation:spinR 14s linear infinite; }
.logo-ring2 { position:absolute; inset:-32px; border-radius:50%; border:1px dashed rgba(212,175,55,0.10); animation:spinR 22s linear infinite reverse; }
@keyframes spinR { to{transform:rotate(360deg)} }
.logo-circle {
  width:160px; height:160px;
  background:radial-gradient(circle at 40% 35%,rgba(255,220,80,0.22),rgba(180,130,10,0.14) 50%,rgba(0,0,0,0.72) 100%);
  border:2px solid rgba(212,175,55,0.58); border-radius:50%;
  display:flex; align-items:center; justify-content:center; position:relative;
  box-shadow:0 0 40px rgba(212,175,55,0.22),0 0 80px rgba(212,175,55,0.09),inset 0 0 40px rgba(0,0,0,0.5);
  animation:lPulse 3s ease-in-out infinite;
}
@keyframes lPulse {
  0%,100%{box-shadow:0 0 40px rgba(212,175,55,0.22),0 0 80px rgba(212,175,55,0.09),inset 0 0 40px rgba(0,0,0,0.5)}
  50%{box-shadow:0 0 65px rgba(212,175,55,0.44),0 0 130px rgba(212,175,55,0.18),inset 0 0 40px rgba(0,0,0,0.5)}
}
.logo-g {
  font-family:'Cinzel',serif; font-size:88px; font-weight:900;
  background:linear-gradient(135deg,#8a5a00 0%,#d4af37 25%,#f7e29c 50%,#d4af37 75%,#8a5a00 100%);
  background-size:300%; -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text;
  animation:gShimmer 3.5s ease-in-out infinite; line-height:1; letter-spacing:-2px;
  filter:drop-shadow(0 0 14px rgba(212,175,55,0.55));
}
@keyframes gShimmer { 0%,100%{background-position:0% 50%} 50%{background-position:100% 50%} }
.sparkle { position:absolute; width:5px; height:5px; background:var(--gold-l); border-radius:50%; animation:spAnim var(--dur,2s) var(--del,0s) ease-in-out infinite; }
@keyframes spAnim {
  0%,100%{opacity:0;transform:scale(0) translate(0,0)}
  30%{opacity:1;transform:scale(1.3) translate(var(--tx,0px),var(--ty,0px))}
  70%{opacity:.4;transform:scale(.7) translate(calc(var(--tx,0px)*2),calc(var(--ty,0px)*2))}
  100%{opacity:0;transform:scale(0) translate(calc(var(--tx,0px)*3),calc(var(--ty,0px)*3))}
}

.hero-badge { display:inline-flex; align-items:center; gap:8px; background:rgba(212,175,55,0.07); border:1px solid rgba(212,175,55,0.28); padding:7px 22px; border-radius:40px; font-size:11px; letter-spacing:3.5px; text-transform:uppercase; color:var(--gold-l); margin-bottom:24px; animation:fu .8s .8s ease both; }
.bdot { width:7px;height:7px;background:var(--gold);border-radius:50%;animation:pulse 2s infinite; }
@keyframes pulse{0%,100%{box-shadow:0 0 0 0 rgba(212,175,55,.6)}50%{box-shadow:0 0 0 5px rgba(212,175,55,0)}}
h1.hero-h { font-family:'Cinzel',serif; font-size:clamp(30px,5.2vw,66px); font-weight:900; line-height:1.06; letter-spacing:.5px; margin-bottom:18px; animation:fu 1s 1s ease both; }
.gold-t { background:linear-gradient(135deg,var(--gold-d) 0%,var(--gold) 30%,var(--gold-l) 55%,var(--gold) 75%,var(--gold-d) 100%); background-size:300%; -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; animation:gShimmer 4s ease-in-out infinite; display:block; }
.hero-sub { font-size:clamp(15px,1.7vw,19px); font-style:italic; font-weight:300; color:var(--wdim); max-width:640px; line-height:1.78; margin-bottom:44px; animation:fu 1s 1.2s ease both; }
.hero-btns { display:flex; gap:14px; flex-wrap:wrap; justify-content:center; animation:fu 1s 1.4s ease both; }
.btn-p { padding:15px 42px; background:linear-gradient(135deg,var(--gold),var(--gold-l),var(--gold)); background-size:200%; color:#000; font-family:'Cinzel',serif; font-size:13px; font-weight:700; letter-spacing:2.5px; text-transform:uppercase; border:none; border-radius:2px; cursor:pointer; transition:all .4s; box-shadow:0 0 30px rgba(212,175,55,0.28); }
.btn-p:hover { background-position:right; transform:translateY(-3px); box-shadow:0 12px 40px rgba(212,175,55,0.55); }
.btn-o { padding:14px 36px; background:transparent; color:var(--gold-l); font-family:'Cinzel',serif; font-size:13px; font-weight:600; letter-spacing:2px; text-transform:uppercase; border:1px solid rgba(212,175,55,0.45); border-radius:2px; cursor:pointer; transition:all .4s; }
.btn-o:hover { background:rgba(212,175,55,0.08); border-color:var(--gold); transform:translateY(-3px); }
.btn-g { padding:14px 28px; background:transparent; color:var(--wdim); font-family:'Cormorant Garamond',serif; font-size:17px; font-weight:400; letter-spacing:1px; border:1px solid rgba(255,255,255,0.12); border-radius:2px; cursor:pointer; transition:all .4s; display:flex; align-items:center; gap:10px; }
.btn-g:hover { border-color:rgba(255,255,255,0.28); color:var(--white); transform:translateY(-2px); }
.play-ic { width:22px;height:22px;background:rgba(212,175,55,0.14);border:1px solid rgba(212,175,55,0.38);border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:8px;color:var(--gold); }
.stats-row { display:flex; gap:50px; margin-top:68px; animation:fu 1s 1.6s ease both; }
.stat { text-align:center; }
.snum { font-family:'Cinzel',serif; font-size:30px; font-weight:700; color:var(--gold); }
.slbl { font-size:11px; letter-spacing:2.5px; text-transform:uppercase; color:var(--wdim); margin-top:4px; }
.sdiv { width:1px; background:linear-gradient(to bottom,transparent,rgba(212,175,55,0.3),transparent); }

@keyframes fu { from{opacity:0;transform:translateY(26px)} to{opacity:1;transform:translateY(0)} }

section { padding:110px 6%; position:relative; z-index:1; }
.sec-label { display:inline-block; font-size:10px; letter-spacing:4px; text-transform:uppercase; color:var(--gold); margin-bottom:12px; }
.sec-title { font-family:'Cinzel',serif; color:var(--white); font-size:clamp(24px,3.5vw,44px); font-weight:700; line-height:1.1; margin-bottom:18px; }
.sec-sub { font-size:17px; font-style:italic; font-weight:300; color:var(--wdim); line-height:1.75; max-width:540px; }
.gline { width:55px;height:2px;background:linear-gradient(90deg,var(--gold),transparent);margin:20px 0; }

/* ABOUT */

.about-in { display:grid; grid-template-columns:1fr 1fr; gap:80px; align-items:center; max-width:1200px; margin:0 auto; }
.about-visual { position:relative; height:440px; display:flex; align-items:center; justify-content:center; }
.orbit { position:absolute; border-radius:50%; border:1px solid rgba(212,175,55,0.14); }
.o1{width:360px;height:360px;animation:sp 26s linear infinite}
.o2{width:270px;height:270px;border-color:rgba(212,175,55,0.19);animation:sp 18s linear infinite reverse}
.o3{width:174px;height:174px;border-color:rgba(212,175,55,0.27);animation:sp 12s linear infinite}
@keyframes sp{to{transform:rotate(360deg)}}
.orbit-center { width:100px;height:100px;background:radial-gradient(circle,rgba(212,175,55,0.18),rgba(212,175,55,0.04));border:2px solid var(--gold);border-radius:50%;display:flex;align-items:center;justify-content:center;font-family:'Cinzel',serif;font-size:9px;letter-spacing:1.5px;text-align:center;color:var(--gold-l);z-index:1;line-height:1.5;box-shadow:0 0 28px rgba(212,175,55,0.2); }
.orbit-dot { position:absolute; border-radius:50%; background:var(--gold); box-shadow:0 0 10px var(--gold); }
.mv-grid { display:grid; grid-template-columns:1fr 1fr; gap:14px; margin-top:26px; }
.mvc { background:rgba(212,175,55,0.04);border:1px solid rgba(212,175,55,0.14);padding:20px;border-radius:2px;transition:all .4s; }
.mvc:hover { background:rgba(212,175,55,0.08);border-color:rgba(212,175,55,0.36);transform:translateY(-4px); }
.mvc h4 { font-family:'Cinzel',serif;font-size:11px;letter-spacing:3px;color:var(--gold);text-transform:uppercase;margin-bottom:8px; }
.mvc p { font-size:14px;color:var(--wdim);line-height:1.6; }
.creds { margin-top:20px;display:flex;flex-direction:column;gap:11px; }
.ci { display:flex;align-items:center;gap:12px;font-size:15px;color:var(--wdim); }
.ci-icon { width:32px;height:32px;min-width:32px;background:rgba(212,175,55,0.08);border:1px solid rgba(212,175,55,0.22);border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:13px; }

/* GALLERY */
.gallery-sec {  background: url('/hero-bg.png') no-repeat center center;
  background-size: cover;
   }
.gallery-grid { display:grid; grid-template-columns:2fr 1fr 1fr; grid-template-rows:240px 240px; gap:10px; margin-top:48px; border-radius:2px; overflow:hidden; }
.gallery-item { position:relative; overflow:hidden; cursor:pointer; }
.gallery-item:first-child { grid-row:span 2; }
.gallery-item img { width:100%;height:100%;object-fit:cover;transition:transform .6s ease,filter .4s;filter:brightness(.65) saturate(.75); }
.gallery-item:hover img { transform:scale(1.06);filter:brightness(.82) saturate(1); }
.gallery-overlay { position:absolute;inset:0;background:linear-gradient(to top,rgba(6,5,10,.88) 0%,transparent 55%);display:flex;align-items:flex-end;padding:18px;opacity:0;transition:opacity .4s; }
.gallery-item:hover .gallery-overlay { opacity:1; }
.gallery-label { font-family:'Cinzel',serif;font-size:13px;letter-spacing:2px;color:var(--gold-l); }
.gallery-item::after { content:'';position:absolute;inset:0;border:1px solid rgba(212,175,55,0);transition:border-color .4s;pointer-events:none; }
.gallery-item:hover::after { border-color:rgba(212,175,55,0.4); }

/* EXPERTISE */
.services-sec {  background: url('/hero-bg.png') no-repeat center center;
  background-size: cover;
   }
.services-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(240px,1fr)); gap:22px; margin-top:48px; }
.card { background:rgba(212,175,55,0.03);border:1px solid rgba(212,175,55,0.14);padding:34px 28px;border-radius:2px;transition:all .45s;position:relative;overflow:hidden; }
.card::before { content:'';position:absolute;top:0;left:0;right:0;height:2px;background:linear-gradient(90deg,transparent,var(--gold),transparent);transform:scaleX(0);transition:transform .4s; }
.card:hover::before { transform:scaleX(1); }
.card:hover { background:rgba(212,175,55,0.07);border-color:rgba(212,175,55,0.30);transform:translateY(-8px);box-shadow:0 20px 50px rgba(0,0,0,0.5),0 0 28px rgba(212,175,55,0.07); }
.card-icon { font-size:30px;margin-bottom:16px;filter:drop-shadow(0 0 6px rgba(212,175,55,0.4)); }
.card h3 { font-family:'Cinzel',serif;font-size:15px;letter-spacing:1px;color:var(--gold-l);margin-bottom:10px; }
.card p { font-size:15px;color:var(--wdim);line-height:1.65; }

/* CITIES */
.cities-sec {  background: url('/hero-bg.png') no-repeat center center;
  background-size: cover; }
.cities-in { display:grid;grid-template-columns:repeat(3,1fr);gap:20px;margin-top:48px; }
.city-card { position:relative;overflow:hidden;border-radius:2px;border:1px solid rgba(212,175,55,0.16);height:300px;cursor:pointer;transition:all .4s; }
.city-card img { width:100%;height:100%;object-fit:cover;transition:transform .6s,filter .4s;filter:brightness(.42) saturate(.55); }
.city-card:hover img { transform:scale(1.07);filter:brightness(.62) saturate(.9); }
.city-overlay { position:absolute;inset:0;background:linear-gradient(to top,rgba(6,5,10,.92) 0%,rgba(6,5,10,.18) 60%,transparent 100%);display:flex;flex-direction:column;justify-content:flex-end;padding:26px 22px; }
.city-card::after { content:'';position:absolute;inset:0;border:2px solid rgba(212,175,55,0);transition:border-color .4s;pointer-events:none; }
.city-card:hover::after { border-color:rgba(212,175,55,0.45); }
.city-tag { font-size:10px;letter-spacing:3px;text-transform:uppercase;color:var(--gold);margin-bottom:7px; }
.city-name { font-family:'Cinzel',serif;font-size:26px;font-weight:700;color:var(--white);margin-bottom:7px; }
.city-desc { font-size:14px;color:var(--wdim);font-style:italic; }

footer { background:#000;text-align:center;padding:38px 5%;border-top:1px solid rgba(212,175,55,0.14);position:relative;z-index:1; }
footer p { font-size:14px;color:var(--wdim);letter-spacing:1px; }
.gold-f { color:var(--gold); }

@media(max-width:900px){
  .nav-links{display:none}
  .about-in{grid-template-columns:1fr;gap:36px}
  .about-visual{height:270px}
  .o1{width:230px;height:230px}.o2{width:175px;height:175px}.o3{width:116px;height:116px}
  .gallery-grid{grid-template-columns:1fr 1fr;grid-template-rows:auto}
  .gallery-item:first-child{grid-row:span 1}
  .cities-in{grid-template-columns:1fr}
  .stats-row{gap:22px;flex-wrap:wrap}
  .sdiv{display:none}
  .mv-grid{grid-template-columns:1fr}
}
@media(max-width:580px){
  .hero-btns{flex-direction:column;align-items:center}
  .gallery-grid{grid-template-columns:1fr}
}
`;

function Particles() {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let W = window.innerWidth,
      H = window.innerHeight;
    canvas.width = W;
    canvas.height = H;
    const resize = () => {
      W = window.innerWidth;
      H = window.innerHeight;
      canvas.width = W;
      canvas.height = H;
    };
    window.addEventListener("resize", resize);
    const dust = Array.from({ length: 200 }, () => ({
      x: Math.random() * W,
      y: Math.random() * H,
      r: Math.random() * 1.3 + 0.2,
      o: Math.random() * 0.55 + 0.1,
      vx: (Math.random() - 0.5) * 0.14,
      vy: (Math.random() - 0.5) * 0.14,
      flicker: Math.random() * Math.PI * 2,
    }));
    const bokeh = Array.from({ length: 16 }, () => ({
      x: Math.random() * W,
      y: Math.random() * H,
      r: Math.random() * 45 + 18,
      o: Math.random() * 0.11 + 0.03,
      vx: (Math.random() - 0.5) * 0.07,
      vy: (Math.random() - 0.5) * 0.06,
      pulse: Math.random() * Math.PI * 2,
    }));
    let frame = 0,
      raf;
    const draw = () => {
      ctx.clearRect(0, 0, W, H);
      frame++;
      bokeh.forEach((b) => {
        b.x += b.vx;
        b.y += b.vy;
        b.pulse += 0.007;
        if (b.x < -60) b.x = W + 60;
        if (b.x > W + 60) b.x = -60;
        if (b.y < -60) b.y = H + 60;
        if (b.y > H + 60) b.y = -60;
        const op = b.o * (0.65 + 0.35 * Math.sin(b.pulse));
        const g = ctx.createRadialGradient(b.x, b.y, 0, b.x, b.y, b.r);
        g.addColorStop(0, `rgba(212,175,55,${op})`);
        g.addColorStop(0.5, `rgba(180,130,10,${op * 0.35})`);
        g.addColorStop(1, "rgba(212,175,55,0)");
        ctx.beginPath();
        ctx.arc(b.x, b.y, b.r, 0, Math.PI * 2);
        ctx.fillStyle = g;
        ctx.fill();
      });
      dust.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        p.flicker += 0.03;
        if (p.x < 0) p.x = W;
        if (p.x > W) p.x = 0;
        if (p.y < 0) p.y = H;
        if (p.y > H) p.y = 0;
        const o = p.o * (0.55 + 0.45 * Math.sin(p.flicker));
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(212,175,55,${o})`;
        ctx.fill();
      });
      if (frame % 200 === 0) {
        const sx = Math.random() * W,
          sy = Math.random() * H * 0.6;
        const ex = sx + Math.random() * 180 - 90,
          ey = sy + 55;
        const sg = ctx.createLinearGradient(sx, sy, ex, ey);
        sg.addColorStop(0, "rgba(212,175,55,0)");
        sg.addColorStop(0.5, "rgba(212,175,55,0.3)");
        sg.addColorStop(1, "rgba(212,175,55,0)");
        ctx.beginPath();
        ctx.moveTo(sx, sy);
        ctx.lineTo(ex, ey);
        ctx.strokeStyle = sg;
        ctx.lineWidth = 1.4;
        ctx.stroke();
      }
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);
  return <canvas id="particles" ref={canvasRef} />;
}

function AnimatedLogo() {
  const sparkles = [
    {
      top: "8%",
      left: "50%",
      "--tx": "0px",
      "--ty": "-18px",
      "--dur": "2.2s",
      "--del": "0s",
    },
    {
      top: "24%",
      left: "91%",
      "--tx": "15px",
      "--ty": "-10px",
      "--dur": "2.8s",
      "--del": ".4s",
    },
    {
      top: "72%",
      left: "89%",
      "--tx": "13px",
      "--ty": "12px",
      "--dur": "2.5s",
      "--del": ".8s",
    },
    {
      top: "87%",
      left: "50%",
      "--tx": "0px",
      "--ty": "17px",
      "--dur": "2.1s",
      "--del": "1.2s",
    },
    {
      top: "72%",
      left: "11%",
      "--tx": "-13px",
      "--ty": "12px",
      "--dur": "2.7s",
      "--del": ".6s",
    },
    {
      top: "24%",
      left: "9%",
      "--tx": "-15px",
      "--ty": "-10px",
      "--dur": "2.4s",
      "--del": "1s",
    },
  ];
  return (
    <div className="logo-wrap">
      <div className="logo-ring" />
      <div className="logo-ring2" />
      <div className="logo-circle">
        <span className="logo-g">G</span>
      </div>
      {sparkles.map((s, i) => (
        <div
          key={i}
          className="sparkle"
          style={{
            top: s.top,
            left: s.left,
            transform: "translate(-50%,-50%)",
            "--tx": s["--tx"],
            "--ty": s["--ty"],
            "--dur": s["--dur"],
            "--del": s["--del"],
          }}
        />
      ))}
    </div>
  );
}

const RE_IMAGES = [
  {
    url: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=900&q=80",
    label: "Luxury Residences",
  },
  {
    url: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&q=80",
    label: "Commercial Towers",
  },
  {
    url: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=600&q=80",
    label: "Premium Villas",
  },
  {
    url: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&q=80",
    label: "Modern Apartments",
  },
  {
    url: "https://images.unsplash.com/photo-1605146769289-440113cc3d00?w=600&q=80",
    label: "Investment Properties",
  },
];
const CITIES = [
  {
    url: "https://res.cloudinary.com/dogwkdiny/image/upload/v1773809769/33-thum_ss0o3y.jpg",
    name: "Karachi",
    tag: "Mega City",
    desc: "Commercial & residential investment projects",
  },
  {
    url: "https://images.unsplash.com/photo-1534536281715-e28d76689b4d?w=800&q=80",
    name: "Lahore",
    tag: "Cultural Hub",
    desc: "High growth property development opportunities",
  },
  {
    url: "https://res.cloudinary.com/dogwkdiny/image/upload/v1773809930/real_state_t7qt64.jpg",
    name: "Islamabad",
    tag: "Capital City",
    desc: "Luxury residential and investment assets",
  },
];
const EXPERTISE = [
  {
    icon: "💼",
    title: "Portfolio Management",
    desc: "Professional capital management using strategic investment planning with proven returns.",
  },
  {
    icon: "🏢",
    title: "Real Estate Investment",
    desc: "High growth property investments with long-term value appreciation across Pakistan.",
  },
  {
    icon: "🏠",
    title: "Rental Income Assets",
    desc: "Secure monthly rental income through professionally managed properties.",
  },
  {
    icon: "📈",
    title: "Diversified Portfolio",
    desc: "Risk-managed investments with balanced asset allocation for maximum stability.",
  },
];
const CREDS = [
  { icon: "🌐", text: "Global business network spanning 3 major cities" },
  { icon: "🔒", text: "Secure, transparent earning platform" },
  { icon: "📊", text: "Real-time income tracking & reporting" },
  { icon: "🤝", text: "Backed by experienced investment professionals" },
  { icon: "⭐", text: "10,000+ active members and growing" },
];
const ORBIT_DOTS = [
  { top: "6%", left: "50%", w: 9 },
  { top: "28%", left: "10%", w: 7 },
  { top: "28%", left: "90%", w: 7 },
  { top: "72%", left: "16%", w: 6 },
  { top: "72%", left: "84%", w: 6 },
  { top: "94%", left: "50%", w: 8 },
];

export default function OurPortfolio() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 55);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);
  return (
    <>
      <style>{css}</style>
      <Particles />

      {/* GALLERY */}
      <section className="gallery-sec">
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <span className="sec-label">Our Portfolio</span>
          <h2 className="sec-title">Premium Properties</h2>
          <div className="gline" />
          <p className="sec-sub">
            Handpicked high-yield real estate assets across Pakistan's most
            dynamic markets.
          </p>
          <div className="gallery-grid">
            {RE_IMAGES.map((img, i) => (
              <div key={i} className="gallery-item">
                <img src={img.url} alt={img.label} loading="lazy" />
                <div className="gallery-overlay">
                  <span className="gallery-label">{img.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* EXPERTISE */}
      <section className="services-sec" id="services">
        <div style={{ maxWidth: 1200, margin: "0 auto", textAlign: "center" }}>
          <span className="sec-label">What We Do</span>
          <h2 className="sec-title">Our Expertise</h2>
          <div className="gline" style={{ margin: "20px auto" }} />
          <div className="services-grid">
            {EXPERTISE.map((e, i) => (
              <div key={i} className="card">
                <div className="card-icon">{e.icon}</div>
                <h3>{e.title}</h3>
                <p>{e.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CITIES */}
      <section className="cities-sec" id="projects">
        <div style={{ maxWidth: 1200, margin: "0 auto", textAlign: "center" }}>
          <span className="sec-label">Where We Operate</span>
          <h2 className="sec-title">Project Locations</h2>
          <div className="gline" style={{ margin: "20px auto" }} />
          <div className="cities-in">
            {CITIES.map((c, i) => (
              <div key={i} className="city-card">
                <img src={c.url} alt={c.name} loading="lazy" />
                <div className="city-overlay">
                  <div className="city-tag">{c.tag}</div>
                  <div className="city-name">{c.name}</div>
                  <div className="city-desc">{c.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
